import { render, staticRenderFns } from "./InteractionItem.vue?vue&type=template&id=dd7fc3e8"
import script from "./InteractionItem.vue?vue&type=script&lang=ts"
export * from "./InteractionItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports